<template>
  <div class="navbar">
    <Loading />
    <v-app-bar :elevation="0" color="white" style="margin-left: -3px;">
      <v-btn icon @click="goBack" v-if="showBackButton">
        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" width="24" height="24" viewBox="0 0 24 24">
          <path d="M20,11V13H8L13.5,18.5L12.08,19.92L4.16,12L12.08,4.08L13.5,5.5L8,11H20Z" />
        </svg>
      </v-btn>
      <div class="__link-logo mr-3 pr-2" v-if="logo">
        <template>
          <img :src="logo" alt="Logo" class="img-logo" />
        </template>
      </div>

      <v-toolbar-title class="font-weight-bold" v-if="title">{{ title }}</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn icon @click="onRefresh" v-if="showRefreshButton">
        <svg width="20" height="14" viewBox="0 0 20 14" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M8 5.99999H5.101C5.101 5.99699 5.101 5.99399 5.102 5.99099C5.167 5.67199 5.265 5.35699 5.393 5.05399C5.519 4.75699 5.674 4.47099 5.854 4.20399C6.032 3.93999 6.238 3.69099 6.464 3.46399C6.691 3.23799 6.94 3.03199 7.206 2.85299C7.472 2.67299 7.757 2.51899 8.054 2.39299C8.356 2.26499 8.671 2.16699 8.992 2.10199C9.65 1.96699 10.349 1.96699 11.01 2.10199C11.328 2.16699 11.644 2.26499 11.947 2.39299C12.243 2.51799 12.528 2.67399 12.797 2.85399C13.063 3.03299 13.311 3.23799 13.535 3.46299L14.951 2.05099C14.637 1.73499 14.287 1.44699 13.915 1.19599C13.542 0.943994 13.142 0.725994 12.727 0.549994C12.302 0.369994 11.859 0.232994 11.412 0.141994C10.489 -0.0470059 9.513 -0.0470059 8.593 0.141994C8.144 0.233994 7.701 0.370994 7.277 0.550994C6.858 0.726994 6.458 0.943994 6.086 1.19599C5.716 1.44499 5.368 1.73299 5.05 2.04999C4.732 2.36699 4.445 2.71599 4.197 3.08499C3.945 3.45799 3.727 3.85799 3.551 4.27499C3.371 4.69899 3.234 5.14199 3.143 5.58999C3.115 5.72499 3.1 5.86299 3.08 5.99999H0L4 9.99999L8 5.99999ZM12 7.99999H14.899C14.898 8.00299 14.899 8.00599 14.898 8.00799C14.832 8.332 14.734 8.64699 14.606 8.94599C14.483 9.23899 14.328 9.52499 14.147 9.79399C13.968 10.058 13.762 10.308 13.534 10.536C13.309 10.761 13.061 10.966 12.795 11.146C12.527 11.326 12.242 11.481 11.946 11.607C11.643 11.735 11.328 11.833 11.008 11.898C10.351 12.033 9.651 12.033 8.991 11.898C8.672 11.833 8.357 11.735 8.054 11.607C7.757 11.481 7.471 11.326 7.204 11.146C6.94 10.968 6.691 10.762 6.464 10.536L5.05 11.95C5.367 12.267 5.716 12.555 6.085 12.804C6.458 13.056 6.858 13.274 7.275 13.45C7.699 13.63 8.142 13.767 8.59 13.858C9.051 13.952 9.525 14 10 14C10.475 14 10.949 13.952 11.408 13.858C11.857 13.767 12.301 13.629 12.725 13.449C13.14 13.273 13.54 13.056 13.913 12.804C14.285 12.553 14.635 12.264 14.948 11.95C15.265 11.633 15.553 11.284 15.803 10.913C16.057 10.536 16.275 10.136 16.448 9.72599C16.626 9.30599 16.763 8.86299 16.856 8.40999C16.883 8.27499 16.899 8.13699 16.919 7.99999H20L16 3.99999L12 7.99999Z"
            fill="#272727" />
        </svg>
      </v-btn>

      <v-btn icon @click="onClose" v-if="showCloseButton" class="mr-1">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
          <path
            d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" />
        </svg>
      </v-btn>

      <v-menu :open="menuOpen" offset-y v-if="showLanguageButton">
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" elevation="0">
            <img :src="selectedFlag" alt="Selected Flag" />
            <v-icon>mdi-chevron-down</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item v-for="(country, index) in countries" :key="index" @click="changeLanguage(country)">
            <img :src="country.flag" alt="Flag" height="25" style="margin-right: 10px" />
            <v-list-item-title>{{ country.name }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <errorMessages v-if="showError" />
    </v-app-bar>
  </div>
</template>

<script>
import errorMessages from '@/components/errorMessages.vue'
import Loading from '@/components/Loading.vue'
import { mapGetters } from "vuex";
import { setQueryParam, removeAllQueryParams, deleteQueryParam } from '@/utils/customQuery'
export default {
  props: {
    logo: String,
    showBackButton: Boolean,
    title: String,
    showLanguageButton: Boolean,
    showRefreshButton: Boolean,
    showCloseButton: Boolean,
  },
  components: {
    errorMessages,
    Loading,
  },
  computed: {
    showError: function () {
      return this.$store.getters.showError
    },
    ...mapGetters(["getRouterData", "getLastRouterData"]),
  },
  data() {
    return {
      menuOpen: false,
      selectedFlag: "https://flagicons.lipis.dev/flags/4x3/id.svg",
      selectedLanguage: "id",
      countries: [
        {
          code: "id",
          name: "Bahasa Indonesia",
          flag: "https://flagicons.lipis.dev/flags/4x3/id.svg",
        },
        {
          code: "en",
          name: "English",
          flag: "https://flagicons.lipis.dev/flags/4x3/gb.svg",
        },
      ],
    };
  },
  methods: {
    goBack() {
      // this.$router.go(-1);
      if (this.getRouterData.length === 0) {
        const url = new URL(window.location.href);
        url.search === "" ? window.location.href = "/" : window.location.replace("/reservation-place")
        store.dispatch("remove_all_router_data");
        this.$store.dispatch("remove_order");
      } else {
        const historyRoute = this.getRouterData[this.getRouterData.length - 2];
        const outputArray = [];
        // Mengubah nama ke dalam bentuk pasangan key-value
        historyRoute && outputArray.push({
          "key": "page",
          "value": historyRoute.name
        });
        // Mengambil nilai dari params jika tersedia
        if (historyRoute && historyRoute.params) {
          for (const key in historyRoute.params) {
            outputArray.push({
              "key": key,
              "value": historyRoute.params[key]
            });
          }
        }
        if (outputArray.length > 0) {
          outputArray.forEach((item) => {
            setQueryParam(item.key, item.value);
          })
        } else {
          deleteQueryParam("page");
          this.$store.dispatch("set_query_router", []);
        }
        this.$store.dispatch("remove_item_router_data", this.getLastRouterData);
      }
    },
    changeLanguage(country) {
      this.selectedLanguage = country.code;
      this.selectedFlag = country.flag;
      this.menuOpen = false;
    },
    onRefresh() {
      this.$emit("onRefresh");
    },
    onClose() {
      removeAllQueryParams()
        this.$store.dispatch("remove_order");
        this.$store.dispatch("removeAllReservation");
    }
  },
};
</script>
